import { useMatch } from "react-router-dom";

/**
 * El segmento `/c/:cliente/` de la URL actual, sea cual sea el punto del árbol de rutas desde el que se lea
 * (un `useParams` en una ruta padre no ve los parámetros de sus hijas). `null` fuera de un cliente.
 */
export function useSlugDeLaUrl(): string | null {
  const match = useMatch({ path: "/c/:cliente", end: false });
  return match?.params.cliente ?? null;
}
